import { featuredSites } from '@/mocks/nav';

export default function FeaturedSites() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-content mx-auto px-4 md:px-10">
        <div className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.28em] text-primary-600">EDITOR'S PICKS</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            本期精选入口，封面一眼可辨
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            我们从各分类里挑出近期访问体验最好的几个站点，配了统一的封面，方便你按图索骥。列表会随线路状态滚动更新。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredSites.map((site) => (
            <article
              key={site.name}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={site.cover}
                  alt={`${site.name} 站点封面`}
                  title={`${site.name} 51网址导航精选入口`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-label">
                  {site.tag}
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900 text-base">
                    <i className={site.icon}></i>
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{site.name}</h3>
                </div>
                <p className="mt-1 font-label text-xs text-foreground-500">{site.domain}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{site.desc}</p>
                <div className="mt-5 pt-4 border-t border-background-200/70 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-500">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                    入口可访问
                  </span>
                  <a
                    href="#latest"
                    className="inline-flex items-center gap-1.5 text-sm font-label text-primary-600 hover:text-primary-700 cursor-pointer"
                  >
                    立即前往
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}